export * from './BasicLayout';
export * from './FullPageLayout';
import React from 'react';
import { BasicLayout } from './BasicLayout';
import { FullPageLayout } from './FullPageLayout';
export const layouts = {
  BasicLayout: /*#__PURE__*/React.createElement(BasicLayout, null),
  FullPageLayout: /*#__PURE__*/React.createElement(FullPageLayout, null)
};